import types from './types';

export const receiveOmniSegmentList = (entity: { data: any[] }) => ({
  type: types.RECEIVE_OMNI_SEGMENT_DATA,
  entity
});

export const startFetchOmniSegment = (entity: { data: any[] }) => ({
  type: types.START_FETCH,
  entity
});

export const endFetchOmniSegment = (entity: { data: any[] }) => ({
  type: types.END_FETCH,
  entity
});
